/* eslint-disable standard/no-callback-literal */
import auth from "@/modules/auth/services/auth";
import axios from "axios";
// eslint-disable-next-line no-unused-vars

var http = axios.create({
    baseURL: process.env.API_BASE_URL,
    headers: { "Content-Type": "application/json" },
});

http.interceptors.response.use(
    function (response) {
        return response;
    },

    function (error) {
        if (error.response.status !== 401) return Promise.reject(error);

        var refreshAndRetry = new Promise(function (resolve) {
            axios
                .post(
                    process.env.API_BASE_URL + "account/refresh_token",
                    {
                        // eslint-disable-next-line no-undef
                        refresh_token: JSON.parse(
                            localStorage.getItem("refresh_token"),
                        ).value,
                    },
                    {
                        headers: {
                            "Content-Type": "application/json",
                            // eslint-disable-next-line no-undef
                            Authorization:
                                "Bearer " +
                                JSON.parse(localStorage.getItem("token")).value,
                        },
                    },
                )
                .then(function (response) {
                    // eslint-disable-next-line no-undef
                    localStorage.setItem(
                        "refresh_token",
                        JSON.stringify({
                            value: response.data.refresh_token,
                            expire: null,
                        }),
                    );

                    // eslint-disable-next-line no-undef
                    localStorage.setItem(
                        "token",
                        JSON.stringify({
                            value: response.data.token,
                            expire: null,
                        }),
                    );

                    return Promise.resolve(response);
                })
                .then(function (response) {
                    var failedRequest = error.config;
                    // eslint-disable-next-line no-undef
                    failedRequest.headers.Authorization =
                        "Bearer " +
                        JSON.parse(localStorage.getItem("token")).value;
                    axios.request(failedRequest).then(function (retryResponse) {
                        resolve(retryResponse);
                    });
                })
                .catch(function (err) {
                    var failedRequest = err.config;
                    // eslint-disable-next-line no-undef
                    var token = JSON.parse(localStorage.getItem("token")).value;
                    auth.doLogout(token, function (result) {
                        if (result.success) {
                            localStorage.clear();
                            store.commit("auth_destroyed");
                            router.push("/");
                        }
                    });

                    // eslint-disable-next-line no-undef
                    failedRequest.headers.Authorization =
                        "Bearer " +
                        JSON.parse(localStorage.getItem("token")).value;
                    axios.request(failedRequest).then(function (retryResponse) {
                        resolve(retryResponse);
                    });
                });
        });

        return refreshAndRetry;
    },
);

function getConfig() {
    return {
        headers: {
            // eslint-disable-next-line no-undef
            Authorization: JSON.parse(localStorage.getItem("token")).value,
        },
    };
}

function getListModul(callback) {
    var config = getConfig();
    http.get("itembank/modules", config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function getModulBelajar(data, callback) {
    var config = getConfig();
    http.get("itembank/module/" + data, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function createModulPembelajaran(data, callback) {
    var config = getConfig();
    var postData = {
        name: data.name,
        subject: data.subject,
        url: data.url,
        semester: data.semester,
        grades: data.grades,
        password: data.password,
        jenjang: data.level,
        status: data.status,
    };

    http.post("itembank/module/create", postData, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function editModulPembelajaran(data, callback) {
    var config = getConfig();
    var postData = {
        name: data.name,
        subject: data.subject,
        url: data.url,
        semester: data.semester,
        password: data.password,
        jenjang: data.level,
        grades: data.grades,
        status: data.status,
    };

    http.put("itembank/module/" + data.id + "/update", postData, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function deleteModulPembelajaran(data, callback) {
    var config = getConfig();
    http.delete("itembank/module/" + data + "/delete", config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

export default {
    getListModul,
    getModulBelajar,
    createModulPembelajaran,
    editModulPembelajaran,
    deleteModulPembelajaran,
};



// WEBPACK FOOTER //
// ./src/modules/modul_belajar_old/services/modulpembelajaran.js